import LoadingContainer from 'components/LoadingContainer'
import { usePrepareCart } from 'hooks/usePrepareCart'
import { useCallback, useEffect } from 'react'
import PageCartProducts from './pageCartProducts'

function NewCartCod() {
  const { getLastOrder, loading } = usePrepareCart()

  const handleStorageChange = useCallback(
    (e: StorageEvent) => {
      if (e.key === 'selectedProducts' || e.key === '@CANNECT:ORDER_CHECKOUT_CART_ID') {
        getLastOrder()
      }
    },
    [getLastOrder]
  )

  useEffect(() => {
    getLastOrder()

    window.addEventListener('storage', handleStorageChange)

    const interval = setInterval(() => {
      getLastOrder(false)
    }, 30000)

    return () => {
      window.removeEventListener('storage', handleStorageChange)
      clearInterval(interval)
    }
  }, [])

  if (loading) return <LoadingContainer loading />

  return <PageCartProducts />
}

export default NewCartCod
